import { PathKind, REQUIRED, SchemaPath, SchemaPathRules, metadata, requiredError, validate } from '@angular/forms/signals';

export function requiredTrimmed<TPathKind extends PathKind = PathKind.Root>(path: SchemaPath<string, SchemaPathRules.Supported, TPathKind>, config?: { message?: string }): void {
  metadata(path, REQUIRED, () => true);
  validate(path, (ctx) => (ctx.value().trim().length > 0 ? undefined : requiredError({ message: config?.message })));
}
